import { useEffect, useMemo, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { apiClient } from "../api/client";
import type { Organization } from "../api/types";
import { roleLabel } from "../utils/labels";
import { switchOrganizationContext } from "../utils/organizationContext";

export function AppShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const organizationIdFromUrl = useMemo(() => location.pathname.match(/^\/organizations\/([^/]+)/)?.[1], [location.pathname]);
  const activeOrganizationId = organizationIdFromUrl ?? "";

  useEffect(() => { void apiClient.listOrganizations().then(setOrganizations).catch(() => setOrganizations([])); }, [location.pathname]);
  const activeOrganization = organizations.find((item) => item.id === activeOrganizationId);

  async function handleLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <div className="app-shell">
      <header className="topbar">
        <NavLink className="brand" to="/organizations" aria-label="DeepVision 首页">
          <span className="brand-mark" aria-hidden="true"><i /><i /><i /></span>
          <span><strong>DeepVision</strong><small>数据标注平台</small></span>
        </NavLink>
        <nav className="main-nav" aria-label="主导航">
          {activeOrganization && <><NavLink to={`/organizations/${activeOrganization.id}/projects`}>项目</NavLink><NavLink to={`/organizations/${activeOrganization.id}/tasks`}>任务</NavLink><NavLink to={`/organizations/${activeOrganization.id}/jobs`}>工作</NavLink></>}
        </nav>
        <label className="organization-switcher">
          <span>当前组织</span>
          <select aria-label="当前组织" value={activeOrganizationId} onChange={(event) => {
            const value = event.target.value;
            if (value === activeOrganizationId) return;
            switchOrganizationContext(value);
          }}>
            <option value="">管理组织</option>
            {organizations.map((item) => <option key={item.id} value={item.id}>{item.name} · {roleLabel(item.role)}</option>)}
          </select>
        </label>
        {activeOrganization && <NavLink className="settings-link" to={`/organizations/${activeOrganization.id}/settings`} aria-label={`${activeOrganization.name} 设置`}>设置</NavLink>}
        <div className="user-menu">
          <span className="user-avatar" aria-hidden="true">{(user?.display_name || user?.username || "U").slice(0, 1).toUpperCase()}</span>
          <span className="user-name">{user?.display_name || user?.username}</span>
          <button className="button ghost compact" type="button" onClick={handleLogout}>退出</button>
        </div>
      </header>
      <main className="page"><Outlet /></main>
    </div>
  );
}
